import { types } from 'mobx-state-tree'

export enum StatusType {
  IDLE = 'idle',
  PENDING = 'pending',
  DONE = 'done',
  ERROR = 'error',
}

export const ModelWithStatus = types
  .model('Status')
  .props({
    status: types.optional(
      types.enumeration<StatusType>(Object.values(StatusType)),
      StatusType.IDLE,
    ),
  })
  .actions((self) => ({
    setStatus(status: StatusType) {
      self.status = status
    },
  }))
